import { Flex, Stack, Text, Image, Divider, Group } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { displayPatientName } from "../../../../utils/CommonUtil";

export default function OpaReportHeader(props) {
  const { t } = useTranslation();

  return (
    <Stack gap={"xs"}>
      <Flex justify={"space-between"} ta={"center"}>
        <Text size={"lg"} fw={600} ta="left">
          {props.title}
        </Text>
        <Group gap={"xs"} wrap="nowrap">
          <Image width={"auto"} src={"/img/logo.png"} height={30} fit="contain" />
        </Group>
      </Flex>
      <Flex justify={"space-between"} ta={"center"}>
        <Text fw={500} ta="left">
          {t("OpaReports.name") + ": " + displayPatientName(props.name)}
        </Text>
        {props.type && (
          <Text fw={500} ta="left">
            {t("OpaReports.type") + ": " + props.type}
          </Text>
        )}
        <Text fw={500} ta="right">
          {t("OpaReports.dob") + ": " + props.dob?.split("T")[0]}
        </Text>
      </Flex>
      <Flex justify={"space-between"} align={"center"}>
        <Text fw={500} ta="left">
          {t("OpaReports.patientId") + ": " + props.uuid}
        </Text>
        <Text fw={500} ta="right">
          {t("TestController." + props.eye)}
        </Text>
      </Flex>
      <Divider size={"md"} color="blue.6" />
    </Stack>
  );
}
